import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dropdown-waiting-room',
  templateUrl: './dropdown-waiting-room.component.html',
  styleUrls: ['./dropdown-waiting-room.component.scss']
})

export class DropdownWaitingRoomComponent {

  hideDropDown = true;
  hideBackground = true;

  constructor() { }

  @Output() fowardToOtherPage = new EventEmitter();

  onToggleDropdown() {
    this.hideDropDown = !this.hideDropDown;
    this.hideBackground = !this.hideBackground;
  }

  openSchedule() {

    this.fowardToOtherPage.emit();
  }
}
